import React from 'react';
import s from './CartItemThumbnail.scss';
import {ItemLink} from '../CartItem/partials/ItemLink/ItemLink';
import classNames from 'clsx';
import {LineItemModel} from '../../../../domain/models/LineItems/LineItem.model';
import {ThumbnailImage} from '@wix/wix-ui-tpa/cssVars';
import {getImageDimensions} from '../../../../domain/utils/itemUtilsWithSideEffect';
import {ProductType} from '@wix/wixstores-client-core';
import {Download, Document, GiftSmall} from '@wix/wix-ui-icons-common/on-stage';
import {useControllerProps} from '../../../../domain/controllers/ControllerContext';

export enum CartItemThumbnailDataHook {
  Image = 'CartItemThumbnailDataHook.Image',
  DefaultImage = 'default-image',
  DefaultImageDigital = 'default-image-digital',
  DefaultImagePhysical = 'default-image-physical',
  Badge = 'product-badge',
  Wrapper = 'product-thumbnail-wrapper',
  Media = 'product-thumbnail-media',
}

const DEFAULT_IMAGE_DEFAULT_SIZE = 50;

export const CartItemThumbnail = ({lineItem, className}: {lineItem: LineItemModel; className?: string}) => {
  const imageDimensions = getImageDimensions(lineItem, CartItemThumbnail.defaultDimensions);
  const {removeBackgroudColorCartItemThumbnail} = useControllerProps().cartStore;

  const renderImage = () => {
    if (!lineItem.attributes.image) {
      return (
        <div
          data-hook={CartItemThumbnailDataHook.DefaultImage}
          className={classNames(s.defaultImage)}
          style={{
            width: imageDimensions.width,
            height: imageDimensions.height,
          }}>
          {lineItem.attributes.itemType === ProductType.DIGITAL ? (
            <Document
              size={DEFAULT_IMAGE_DEFAULT_SIZE.toString()}
              data-hook={CartItemThumbnailDataHook.DefaultImageDigital}
            />
          ) : (
            <GiftSmall
              size={DEFAULT_IMAGE_DEFAULT_SIZE.toString()}
              data-hook={CartItemThumbnailDataHook.DefaultImagePhysical}
            />
          )}
        </div>
      );
    }

    return (
      <div className={classNames(s.productImage)} data-hook={CartItemThumbnailDataHook.Wrapper}>
        <ThumbnailImage
          src={lineItem.attributes.image.id ?? /* istanbul ignore next */ lineItem.attributes.image.url}
          width={imageDimensions.width}
          height={imageDimensions.height}
          alt={lineItem.name}
          data-hook={CartItemThumbnailDataHook.Media}
          aria-hidden={false}
        />
        {lineItem.attributes.itemType === ProductType.DIGITAL && (
          <div className={classNames(s.productBadge)} data-hook={CartItemThumbnailDataHook.Badge}>
            <Download />
          </div>
        )}
      </div>
    );
  };

  return (
    <div
      className={classNames(
        removeBackgroudColorCartItemThumbnail ? s.thumbnail : /* istanbul ignore next */ s.thumbnailOld,
        className
      )}
      data-hook={CartItemThumbnailDataHook.Image}>
      <ItemLink lineItem={lineItem} tabIndex={-1}>
        {renderImage()}
      </ItemLink>
    </div>
  );
};

CartItemThumbnail.defaultDimensions = {width: 100, height: 100};
